import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { Link } from "gatsby";
import React, { memo } from "react";
import ResponsiveContainer from "./ResponsiveContainer";

interface Props {}

const GetInTouch: React.FC<Props> = () => {
  return (
    <Box bg={"primary700"} py={2} color={"white"}>
      <ResponsiveContainer>
        <Flex
          direction={{ base: "column", lg: "row" }}
          alignItems="center"
          justifyContent={"center"}
        >
          <Box my={2}>
            <Text
              textStyle={"h4"}
              mr={{ base: 0, md: 10 }}
              textAlign={"center"}
            >
              Want some help finding the CDI products that fit your needs?
            </Text>
          </Box>
          <Box my={2}>
            <Link to="/contact-us">
              <Button colorScheme="white" border={"2px solid white"}>
                <Text textStyle={"h5"}>Get In Touch</Text>
              </Button>
            </Link>
          </Box>
        </Flex>
      </ResponsiveContainer>
    </Box>
  );
};

export default memo(GetInTouch);
